module.exports = __webpack_public_path__ + "media/images/mailer/person-24-dark_light-8e368e640598383486838ab64055f106.png";